const CardsType = {
  NO_SPECIALTY: 'NO_SPECIALTY',
  END_COMMON: 'END_COMMON',
  END_PERSONAL: 'END_PERSONAL',
  NO_MATERIALS: 'NO_MATERIALS',
  SHARE_MOBILE: 'SHARE_MOBILE',
  COMMON: 'COMMON',
  FUTURE_WEBINAR: 'FUTURE_WEBINAR',
  TEASER_MAIN: 'TEASER_MAIN',
  FULL_MAIN: 'FULL_MAIN',
}

const Option = {
  personal: 'Моя лента',
  popular: 'Популярные',
}

const OptionsKey = {
  [Option.personal]: 'personal',
  [Option.popular]: 'popular',
}

const optionNames = [Option.personal, Option.popular]

const OptionAliases = [
  {
    option: Option.personal,
    alias: 'personal',
  },
  {
    option: Option.popular,
    alias: 'popular',
  },
]

export { CardsType, Option, optionNames, OptionAliases, OptionsKey }
